/**
 * Enum representing the rarity levels of a Dooplicator NFT.
 */
export enum DooplicatorRarity {
  /**
   * Represents a very common rarity level.
   */
  VeryCommon = 'Very Common',

  /**
   * Represents a common rarity level.
   */
  Common = 'Common',

  /**
   * Represents a rare rarity level.
   */
  Rare = 'Rare',
}
